import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Form } from 'antd';
import { useForm } from "antd/lib/form/Form";
import Button from "components/button";
import AddressFilter from "components/search/AddressFilter";
import { FormatDateValue, buildFilters } from "../../utils/index";
import APIService from '../../services/apiservice';


function TopFarmersSearchFilter({ applyFilters, filters, searchFilterHandler,
	...props }) {

  	const [form] = useForm();
	
	useEffect(() => {
		if (filters) {
			const { date_from, date_to, ...rest } = filters;
			form.setFieldsValue(filters);
			onSubmit(form.getFieldsValue());
		}
	}, [filters, form]);

  	const onSubmit = (formData) => {
		const filterData = buildFilters(formData);
		APIService.setTopFarmersFilters(filterData);

		if(searchFilterHandler){
			searchFilterHandler(filterData);
		}
	}

	const resetFilters = () => {
		form.resetFields();
		onSubmit({});
	}

  return (
	<div>
		<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
			layout="vertical"
			onFinish={onSubmit}
		>
			<div className="border-y py-2">
				<h2 className="font-black">By Location</h2>
				<AddressFilter className="form-column-4" form={form} filters={filters}/>
			</div>

			<div className="dark:bg-intsamis-900 text-right mt-4">
				<Button type="button" className="mx-3 min-w-[100px] text-center " onClick={resetFilters}>
					Reset
				</Button>
				<Button type="submit" className="mx-3 min-w-[100px] text-center ">
					Apply
				</Button>
			</div>
		</Form>
	</div>
  );
}

const mapStateToProps = (state) => ({
	filters: state.dashboard.topFarmersFiters,
});

const mapDispatchToProps = (dispatch) => ({
  
});


export default connect(mapStateToProps, mapDispatchToProps)(TopFarmersSearchFilter);
